<form class="w-100" name="forgotPassword" (ngSubmit)="onSubmit()" method="get" accept-charset="utf-8">
  <div class="container-fluid">
    @if (error != null && error != '') {
      <div class="row justify-content-center">
        <div class="text-danger">{{error}}</div>
      </div>
    }
    <div class="row justify-content-center">
      <div class="input-group mb-3 col-lg-6">
        <div class="input-group-prepend">
          <span class="input-group-text" id="basic-addon1" style="padding-left: 1em; padding-right: 1em">Password</span>
        </div>
        <input [(ngModel)]="reset.Password" type="password" class="form-control" placeholder="New Password"
          aria-label="New Password" aria-describedby="basic-addon1" name="new Password"
          required minlength="8" maxlength="15" ngModel pattern="^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})">
          <!--<span class="input-group-text" ng-click="toggleShowPassword()">
          <i class="fa fa-eye-slash"></i>
        </span>-->
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="input-group mb-3 col-lg-6">
        <div class="text-info">
          Password Policy:
          <br />At least 8 characters
          <br />1 Uppercase
          <br />1 Lowercase
          <br />1 Number
          <br />Inclusion of at least one special character, eg. ! &#64; # $ % ^ & * ? _ ~ - ( )
          <br />No common words
          <br />No username
          <br />No spaces
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="input-group mb-3 col-lg-6">
        <div class="input-group-prepend">
          <span class="input-group-text" id="basic-addon2" style="padding-left: 1em; padding-right: 1em">Password</span>
        </div>
        <input [(ngModel)]="reset.RepeatPassword" type="password" class="form-control" placeholder="Repeat New Password"
          aria-label="Repeat New Password" aria-describedby="basic-addon2" name="repeatPassword"
          required minlength="8" maxlength="15" ngModel pattern="^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})">

          <!--<span class="input-group-text" ng-click="toggleShowRepeatPassword()">
          <i class="fa fa-eye-slash"></i>
        </span>-->
        <div class="input-group-append">
          <button [disabled]="!isValidGuid" role="button" aria-label="Submit" class="btn btn-outline-primary"
            type="submit" name="submit" id="button-addon2">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
